import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import NuDate from "../../../../Components/Utils/NuDate";
import { Progress } from "antd";
import Modal from "../../../../Components/Utils/AttachmentView";
import PDFViewer from "../../../../Components/Utils/PDFViewer";
import FilesView from "../../../../Components/Utils/FilesView";
import ViewIcon from "../../../../Components/Icons/ViewIcon";
import EditIcon from "../../../../Components/Icons/Edit";
import DeleteIcon from "../../../../Components/Icons/Delete";
import axiosInstance from "../../../../Services/axiosCommon";
import { useToast } from "../../../../Components/Others/ToastServices";
import EditTaskAssignee from "./EditTaskAssignee";
import ViewTask from "./ViewTask";
import InSchedulelayout from "./InSchedulelayout";
import { GetAccess } from "../../../../Components/Utils/roles";
import ApprovalComponent from "../../../../Components/Utils/approvalComponent";
import { CalendarDays } from "lucide-react";

function ViewShedule() {
  const { scheduleViewId } = useParams();
  const location = useLocation();
  const cdata = location.state?.data;
  const [tasks, setTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [percentOpenTask, setPercentOpenTask] = useState(false);
  const [newCompletion, setNewCompletion] = useState(0);
  const [loading, setLoading] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const [data, setData] = useState(cdata ? cdata : null);
const[isSubmit,setisSubmited]=useState(false)

  function getView() {
    axiosInstance
      .get(`/schedules/${scheduleViewId}`)
      .then((res) => {
        setData(res.data?.data);
                setisSubmited(res.data?.data?.isSubmitted === true);       

      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  useEffect(() => {
    getView();
  }, []);

  useEffect(() => {
    fetchTasks();
  }, [data]);

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/calendar/tasks/${scheduleViewId}`
      );
      setTasks(response.data?.data);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log(selectedTask, "selectedTasks");

  const handleUpdateCompletion = async () => {
    if (!selectedTask) return;

    try {
      setLoading(true);
      await axiosInstance.put(`/calendar/task-completion/${selectedTask.id}`, {
        taskCompletion: newCompletion,
      });
      fetchTasks();
      setPercentOpenTask(false);
    } catch (error) {
      console.error("Error updating task completion:", error);
    } finally {
      setLoading(false);
    }
  };

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const toast = useToast();

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
    setItemToDelete(null);
  };
  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setShowDeleteConfirm(true);
  };
  const confirmDelete = async (id) => {
    if (!itemToDelete) return;

    try {
      const res = await axiosInstance.delete(
        `/schedules/task/${selectedTask.id}`
      );
      if (res?.data?.status) {
        fetchTasks();
        toast.open({
          type: "success",
          message: "Success",
          description: res.data?.msg || "Deleted Successfully.",
        });
      } else {
        toast.open({
          type: "error",
          message: "Error",
          description: res.data.error || "Network error.",
        });
      }
    } catch (err) {
      toast.open({
        type: "error",
        message: "Error",
        description: err.response?.data?.error || "Delete failed.",
      });
    } finally {
      setShowDeleteConfirm(false);
      setItemToDelete(null);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, ] = useState(null);
  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments?.length > 0 ? data?.attachments : []);
    }
  }, [data]);

  const [showPdfComponent, setShowPdfComponent] = useState(false);

    const [viewPDF, setViewPDF] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(true);

const ViewPDF = async (id, formId) => {
    try {
      setPdfLoading(true);
      setShowPdfComponent(true);

      // Determine API URL based on formId
      let apiUrl;

      if (formId === 20) {
        apiUrl = `/fieldservicereport/report/${id}`;
      } else if (formId === 21) {
        apiUrl = `/generator/report/${id}`;
      } else if (formId >= 1 && formId <= 19) {
        apiUrl = `/schedules/report/${id}`;
      } else {
        apiUrl = `/schedules/inspection_certificate/${id}`;
      }

      console.log(`Fetching PDF from: ${apiUrl}`);

      const response = await axiosInstance.get(apiUrl, {
        responseType: "blob",
        timeout: 30000,
      });

      if (!response?.data || response.data.size === 0) {
        throw new Error("Empty PDF response received");
      }

      // Convert to Blob and generate object URL
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      setViewPDF(pdfUrl);
    } catch (error) {
      console.error("Error downloading PDF:", error);
      let errorMessage = "Failed to load PDF";
      
      if (error.code === 'ECONNABORTED') {
        errorMessage = "Request timeout. Please try again.";
      } else if (error.response?.status === 404) {
        errorMessage = "PDF not found for this inspection.";
      } else if (error.response?.status === 500) {
        errorMessage = "Server error. Please try again later.";
      }
      
      toast.open({
        type: "error",
        message: "Error",
        description: errorMessage,
      });
      setShowPdfComponent(false);
    } finally {
      setPdfLoading(false);
    }
  };

  // Fixed handlePdfIconClick function
  const handlePdfIconClick = (pdfItem) => {
    if (pdfItem && pdfItem.id && pdfItem.formId) {
      ViewPDF(pdfItem.id, pdfItem.formId);
    } else {
      // Handle the main inspection schedule PDF
      ViewPDF(scheduleViewId, null);
    }
  };

  // Fetch all PDFs
  function getAllPDFs(Id) {
    axiosInstance.get(`/schedules/reports/${Id}`)
      .then((res) => {
        setListOfPDFs(res.data || []);
      })
      .catch((err) => {
        console.error("Error fetching PDFs:", err);
        toast.open({
          type: "error",
          message: "Error",
          description: "Failed to load reports",
        });
      });
  }



  const [listOfPDFs, setListOfPDFs] = useState([])


  useEffect(() => {
    getAllPDFs(scheduleViewId)
  }, [scheduleViewId, data]);

  const id = scheduleViewId; 
  const getUrl = `/schedules/get-status`;
  const putUrl = `/schedules/edit-status`; 
  const statusUrl = '/schedules/all-status';


  return (
    <InSchedulelayout EditAccess={GetAccess("inspection_schedule_edit")}>
        <div className="w-full mx-auto h-[calc(100vh-160px)] mt-0.5    md:flex gap-x-2 text-[#111537]">
          <div className="md:w-[70%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
            <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
              <div className="grid  items-center px-2 w-[70%]">
                <div className="sm:flex text-[14px] mb-2 text-[#111537] font-semibold ">
                  <p className=" pr-[2px] ">
                    {data?.refNumber} {""} : {""}{data?.description || "None"}
                  
                  </p>
                </div>
                <div className="flex gap-4 justify-between">
                  <p className="flex items-center gap-2 text-xs text-[#111537]">
                    <CalendarDays size={14} className="text-gray-500 shrink-0" />
                    {data?.date ? (
                      <NuDate value={data?.date} format="DD-MMM-YYYY" />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
              </div>
             <div className=" flex items-center mt-2 sm:mt-0  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-baseColor-primary">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                              {data?.status || "-"}
                            </div>
                          </div>
            </div>

            <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
              <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
                <div className=" w-full sm:grid grid-cols-2 gap-x-8 ">
                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Assignee
                    </p>

                    <div className="w-[65%] py-2 text-xs font-medium text-[#606279] flex flex-wrap">
                      <span className="mr-1">:</span>
                      {data?.assignees?.map((assignees, idx) => (
                        <span
                          key={idx}
                          className="text-xs font-medium  text-[#606279] mr-1"
                        >
                          {assignees.assigneeName}
                          {idx < data.assignees.length - 1 && ","}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Location
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      : {data?.location}
                    </p>
                  </div>
                  <div className="w-full flex px-2">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                      Location Map
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                      : {data?.locationMap}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex gap-4 mt-4">
                <div className="w-full sm:w-[50%]">
  <p className="p-1 text-xs font-medium text-[#111537]">Google Coordinates</p>

  <div className="border border-gray-300 h-[190px] text-xs rounded-lg p-2">
    {data?.googleCoordinates ? (
      data.googleCoordinates.includes("https://www.google.com/maps/embed") ? (
        <div className="overflow-hidden rounded-md">
          <iframe
            src={data.googleCoordinates}
            width="100%"
            height="180"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </div>
      ) : (
        <div className="overflow-y-auto max-h-28 break-words">
          {data.googleCoordinates}
        </div>
      )
    ) : (
      <div className="text-gray-400">No Coordinates Available</div>
    )}
  </div>
</div>

                 <div className=" w-full sm:w-[50%] ">
                  <p className=" p-1 text-xs font-medium text-[#111537]">
                    Attachments
                  </p>
                  <div className=" border border-gary  overflow-y-scroll h-[190px] rounded-lg p-2">
                    <div className="w-full flex gap-2 flex-wrap ">
                      {data?.attachments &&
                        filePathList.map((imgs, idx) => {
                          console.log("img", imgs);
                          return <FilesView fileView={imgs} key={idx} />;
                        })}
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
            <div className="h-[98%] overflow-y-scroll p-2 ">
               {GetAccess("approvals") && isSubmit &&(
<ApprovalComponent id={id} getUrl={getUrl} putUrl={putUrl} statusUrl={statusUrl} refSetData={setData} data={data} type={"schedules"} preUrlName={"schedules"}/>
 )}
              <div className="w-full grid  border border-gary mt-2   rounded-lg">
                <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                  <p className="text-xs text-white font-medium">
                   Details
                  </p>
                </div>
            {GetAccess("client_details") &&(
              <>
                <div className="w-full flex px-2 justify-between">
                  <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                    : {data?.clientName}
                  </p>
                </div>
                <div className="w-full flex px-2 justify-between">
                  <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                    {" "}
                    Reference
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                    {" "}
                    : {data?.clientRefNumber}
                  </p>
                </div>
                </>

            )}
                <div className="w-full flex px-2 justify-between">
                  <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                    {" "}
                    Contract
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                    {" "}
                    : {data?.contractRefNumber}
                  </p>
                </div>
              </div>

              <div className="w-full grid border border-gary mt-4 rounded-lg">
  <p className="text-xs text-white font-medium bg-baseColor-primary p-2 rounded-t-lg">
    Report
  </p>
  <div className="w-full flex flex-wrap overflow-y-scroll h-auto">
   
                <div className="w-full flex flex-wrap overflow-y-scroll h-auto">
                  {/* Main Inspection Schedule PDF */}
                  <div
                    onClick={() => handlePdfIconClick(null)}
                    className="cursor-pointer m-1 w-auto h-[25px] flex items-center justify-between rounded p-[2px] border hover:bg-gray-50 transition-colors"
                    title="View Inspection Schedule"
                  >
                    <svg
                      width="16"
                      height="16"
                      className="fill-current text-baseColor-primary"
                      viewBox="0 0 512 512"
                    >
                      <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                    </svg>
                    <span className="w-auto text-[9px] ml-1">Inspection Schedule</span>
                  </div>

                  {/* Additional PDF Reports */}
                  {listOfPDFs.map((pdf, idx) => (
                    <div
                      key={idx}
                      onClick={() => handlePdfIconClick(pdf)}
                      className="cursor-pointer m-1 w-auto h-[25px] flex items-center justify-between rounded p-[2px] border hover:bg-gray-50 transition-colors"
                      title={`View ${pdf?.formName || 'Report'}`}
                    >
                      <svg
                        width="16"
                        height="16"
                        className="fill-current text-baseColor-primary"
                        viewBox="0 0 512 512"
                      >
                        <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                      </svg>
                      <span className="w-auto text-[9px] ml-1">
                        {pdf?.formName || `Report ${idx + 1}`}
                      </span>
                    </div>
                  ))}

                  {listOfPDFs.length === 0 && (
                    <div className="text-center w-full py-4 text-gray-400 text-xs">
                      No reports available
                    </div>
                  )}
                </div>
  </div>
</div>
            </div>
          </div>
        </div>
        <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {selectedImage?.file.split(".").reverse()[0] == "pdf" ? (
            <PDFViewer pdfFile={selectedImage?.file} />
          ) : (
            <img src={selectedImage?.file} alt={selectedImage?.file} />
          )}
        </Modal>
        {isTaskModalOpen && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in min-w-[97%] max-w-[100%] h-[98%] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-sm font-semibold">Task Details</h3>
                <button
                  onClick={() => setIsTaskModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700 text-2xl"
                >
                  ×
                </button>
              </div>

              <div className="overflow-x-auto ">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[30%]">
                        Description
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[10%]">
                        Date
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[15%]">
                        Assignee
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[10%]">
                        Status
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[10%]">
                        Completion
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-900 w-[5%]">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {tasks.map((task) => (
                      <tr key={task.id}>
                        <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[30%]">
                          {task.description || "N/A"}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[10%]">
                          {task.date ? (
                            <NuDate value={task.date} format="DD-MMM-YYYY" />
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[15%]">
                          {task.assignees?.length > 0 ? (
                            <div className="flex flex-wrap gap-1">
                              {task.assignees.map((assignee, index) => (
                                <span
                                  key={index}
                                  className="inline-block bg-gray-100 rounded-full px-2 py-0.5 text-xs text-gray-700"
                                >
                                  {assignee.assigneeName ||
                                    `Assignee ${index + 1}`}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <span className="text-gray-400">Unassigned</span>
                          )}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[10%]">
                          {task.status || "N/A"}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-500 w-[10%]">
                          <Progress
                            onClick={() => {
                              setSelectedTask(task);
                              setNewCompletion(task.taskCompletion || 0);
                              setPercentOpenTask(true);
                            }}
                            type="circle"
                            size={30}
                            strokeWidth={12}
                            format={(percent) => (
                              <span
                                className={`cursor-pointer ${
                                  percent > 95
                                    ? "text-[#87d068]"
                                    : percent > 50
                                    ? "text-[#108ee9]"
                                    : "text-[#D2BD00]"
                                } text-xs font-semibold`}
                              >
                                {percent}
                              </span>
                            )}
                            percent={
                              typeof task.taskCompletion === "number"
                                ? task.taskCompletion
                                : 0
                            }
                            strokeColor={
                              (task.taskCompletion || 0) > 95
                                ? { "0%": "#87d068", "100%": "#87d068" }
                                : (task.taskCompletion || 0) > 50
                                ? { "0%": "#108ee9", "100%": "#108ee9" }
                                : { "0%": "#D2BD00", "100%": "#D2BD00" }
                            }
                          />
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium">
                          <div className="flex gap-2">
                            <span
                              className="flex justify-end"
                              onClick={() => {
                                setSelectedTask(task);
                                setIsViewModalOpen(true);
                              }}
                            >
                              <ViewIcon />
                            </span>
                            <span
                              className="flex justify-end"
                              onClick={() => {
                                setSelectedTask(task);
                                setIsEditModalOpen(true);
                              }}
                            >
                              <EditIcon height="14" color="blue" />
                            </span>

                            <button
                              className="text-red-500 hover:text-red-700 "
                              onClick={() => handleDeleteClick(task)}
                              disabled={loading}
                            >
                              <DeleteIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {percentOpenTask && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in min-w-[40%] max-w-[90%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">
                  Update Task Completion
                </h3>
                <button
                  onClick={() => setPercentOpenTask(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  ×
                </button>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Task Percentage
                </label>
                <div className="flex items-center gap-2">
                  <input
                    type="number"
                    className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    value={newCompletion}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      if (!isNaN(value) && value >= 0 && value <= 100) {
                        setNewCompletion(value);
                      }
                    }}
                    min={0}
                    max={100}
                    placeholder="0"
                  />
                  <span>%</span>
                </div>
              </div>

              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setPercentOpenTask(false)}
                  className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
                >
                  Cancel
                </button>
                <button
                  onClick={handleUpdateCompletion}
                  disabled={loading}
                  className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isEditModalOpen && (
          <EditTaskAssignee
            open={isEditModalOpen}
            onCancel={() => setIsEditModalOpen(false)}
            task={selectedTask}
            id={selectedTask?.id}
            fetchTasks={fetchTasks}
          />
        )}
        {isViewModalOpen && (
          <ViewTask
            open={isViewModalOpen}
            onCancel={() => setIsViewModalOpen(false)}
            task={selectedTask}
            id={selectedTask?.id}
            fetchTasks={fetchTasks}
          />
        )}

        {showDeleteConfirm && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
              <h3 className="text-sm font-medium mb-4">Warning</h3>
              <p className="mb-6 text-xs">
                Are you sure, you want to delete this Task?
              </p>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={cancelDelete}
                  className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md flex items-center text-textColor-main bg-[#E6F2F2] cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelete}
                  className="px-4 py-[8px] text-xs bg-textColor-main cursor-pointer rounded-md text-white"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
      {showPdfComponent && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in relative w-[98%] h-[98%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <button
              className="absolute top-2 right-2 text-white bg-red-600"
              onClick={() => setShowPdfComponent(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <PDFViewer pdfFile={viewPDF} isLoad={pdfLoading} />
          </div>
        </div>
      )}
    </InSchedulelayout>
  );
}

export default ViewShedule;
